import { formatDateInput } from "@utils/formatDate";
import { formatVolumeWithoutDivision } from "@utils/formatVolume";

import {
  MeterUploadRowStatus,
  type MeterUploadRow,
} from "./buildTrialRunRow";
import { newRowId } from "./newRowId";

// One spreadsheet row after UploadFile parses + zod-validates the workbook: readAt
// has been parsed to a Date (the file schema is `readAt: z.date()`); the remaining
// columns carry their raw validated values.
export type ParsedUploadRow = {
  accountNumber: string;
  extractionPointName: string;
  serialNo?: string;
  reading: number;
  readAt: Date;
  note?: string;
  // group / seq are only present on seqwater workbooks and arrive untyped from the
  // zod conditional spread, so they're narrowed defensively below.
  group?: unknown;
  seq?: unknown;
};

// Map validated upload rows to draft trial-run rows. readAt is normalised from the
// parsed Date to the yyyy-MM-dd string that MeterUploadRowData.readAt is typed as and
// that the rest of the flow relies on: leaving it a Date makes string operations on
// it (e.g. isRowReadyForTrialRun's `.trim()`) throw, which silently aborts the trial
// run so no row ever validates.
export const buildUploadRows = (parsed: ParsedUploadRow[]): MeterUploadRow[] =>
  parsed.map(i => ({
    id: newRowId(),
    rowData: {
      accountNumber: i.accountNumber,
      extractionPointName: i.extractionPointName,
      serialNo: i.serialNo,
      readAt: formatDateInput(i.readAt),
      reading: Number(formatVolumeWithoutDivision(i.reading, "")),
      group: typeof i.group === "string" ? i.group : undefined,
      seq: i.seq ? Number(Number(i.seq).toFixed(3)) : undefined,
      note: typeof i.note === "string" ? i.note : undefined,
    },
    status: MeterUploadRowStatus.Draft,
  }));
